<template>
  <div
    class="border-t border-slate-100"
    style="box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1)"
  >
    <div class="container pt-12">
      <div class="text-center">
        <NuxtImg
          :quality="30"
          src="/assets/logo-bali-bikes-main-hz.png"
          alt="logo-balibikes"
          class="w-64 mb-8 mx-auto"
        />

        <p class="mb-2">Plan Your Trip - Don't have a bike yet?</p>
        <DialogBookingNow />
      </div>

      <div class="my-8 border-t border-gray-300"></div>

      <div class="flex flex-col sm:flex-row w-full sm:justify-between gap-4">
        <div class="flex flex-col justify-between">
          <div class="grid grid-cols-2 sm:grid-cols-4 gap-4">
            <div class="flex flex-col gap-2">
              <div class="font-medium">Company</div>
              <div class="flex flex-col gap-2 text-black/70">
                <span
                  v-for="link in linksCompany"
                  :key="link.path"
                  class="hover:underline text-primary"
                >
                  <div
                    v-if="link.path == 'contact-us'"
                    @click="toWA"
                    class="cursor-pointer text-primary"
                  >
                    {{ link.label }}
                  </div>
                  <NuxtLink v-else :href="link.path" class="text-primary">
                    {{ link.label }}
                  </NuxtLink>
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <div class="font-medium">Service</div>
              <div class="flex flex-col gap-2 text-black/70">
                <span
                  v-for="link in linksServices"
                  :key="link.path"
                  class="hover:underline text-primary"
                >
                  <NuxtLink :href="link.path">
                    {{ link.label }}
                  </NuxtLink>
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <div class="font-medium">Social Media</div>
              <div class="flex gap-2 text-black/70">
                <NuxtLink
                  href="https://www.facebook.com/profile.php?id=61568287402440"
                  target="_blank"
                  aria-label="Visit our Facebook: Bali Bikes Island"
                >
                  <Icon name="logos:facebook" size="25" />
                </NuxtLink>

                <NuxtLink
                  href="https://www.instagram.com/balibikesisland"
                  target="_blank"
                  aria-label="Visit our Instagram: @balibikesisland"
                >
                  <Icon name="skill-icons:instagram" size="25" />
                </NuxtLink>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <div class="font-medium">More</div>
              <div class="flex flex-col gap-2 text-black/70">
                <span
                  v-for="link in linksMore"
                  :key="link.path"
                  class="hover:underline text-primary"
                >
                  <NuxtLink :href="link.path">
                    {{ link.label }}
                  </NuxtLink>
                </span>
              </div>
            </div>
          </div>
          <NuxtImg
            src="/assets/logo-wi-final.png"
            alt="logo-wi-final"
            width="257"
            height="84"
            quality="100"
            loading="eager"
            format="webp"
            class="mx-auto sm:mx-0 my-12 sm:my-0"
            priority
          />
        </div>

        <div>
          <p class="mb-4 font-semibold">Payment</p>
          <NuxtImg
            src="/assets/payment-methods.png"
            alt="payment-methods"
            format="webp"
            width="257"
            quality="100"
            loading="eager"
            class="w-full sm:w-[300px]"
          />
        </div>
      </div>

      <div class="mt-8 border-t border-gray-300"></div>
    </div>
  </div>

  <div class="w-full text-center py-4 mt-6 text-sm md:text-md">
    ©️ PT Butala Lingkar Bangun {{ dayjs().year() }} All right reserved.
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";

const toWA = () => {
  window.open("https://wa.me/62811194881", "_blank");
};

const linksCompany = [
  { path: "about-us", label: "About Us" },
  { path: "contact-us", label: "Contact Us" },
  { path: "faq", label: "FAQ" },
  { path: "blog", label: "Blog" },
];

const linksServices = [
  { path: "bike", label: "Bike Collection" },
  { path: "contact-us", label: "Airport Transfer" },
  { path: "tour", label: "Tour" },
];

const linksMore = [
  { path: "privacy-policy", label: "Privacy Policy" },
  { path: "terms-of-service", label: "Term and Service" },
];
</script>
